/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Hint_NavigateInputs */

const en_search_hint_navigate = /** @type {((inputs: Search_Hint_NavigateInputs) => LocalizedString) & { parts: (inputs: Search_Hint_NavigateInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Search_Hint_NavigateInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (` to navigate`)
		}),
		{
			parts: /** @type {(inputs: Search_Hint_NavigateInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-standalone", name: "up", options: {}, attributes: {} }, { type: "markup-standalone", name: "down", options: {}, attributes: {} }, { type: "text", value: " to navigate" }])
			})
		}
	)
);

const zh_hans1_search_hint_navigate = /** @type {((inputs: Search_Hint_NavigateInputs) => LocalizedString) & { parts: (inputs: Search_Hint_NavigateInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Search_Hint_NavigateInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (` 切换`)
		}),
		{
			parts: /** @type {(inputs: Search_Hint_NavigateInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-standalone", name: "up", options: {}, attributes: {} }, { type: "markup-standalone", name: "down", options: {}, attributes: {} }, { type: "text", value: " 切换" }])
			})
		}
	)
);

const pt_br2_search_hint_navigate = /** @type {((inputs: Search_Hint_NavigateInputs) => LocalizedString) & { parts: (inputs: Search_Hint_NavigateInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Search_Hint_NavigateInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (` para navegar`)
		}),
		{
			parts: /** @type {(inputs: Search_Hint_NavigateInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-standalone", name: "up", options: {}, attributes: {} }, { type: "markup-standalone", name: "down", options: {}, attributes: {} }, { type: "text", value: " para navegar" }])
			})
		}
	)
);

const es_search_hint_navigate = /** @type {((inputs: Search_Hint_NavigateInputs) => LocalizedString) & { parts: (inputs: Search_Hint_NavigateInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Search_Hint_NavigateInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (` para navegar`)
		}),
		{
			parts: /** @type {(inputs: Search_Hint_NavigateInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-standalone", name: "up", options: {}, attributes: {} }, { type: "markup-standalone", name: "down", options: {}, attributes: {} }, { type: "text", value: " para navegar" }])
			})
		}
	)
);

const fr_search_hint_navigate = /** @type {((inputs: Search_Hint_NavigateInputs) => LocalizedString) & { parts: (inputs: Search_Hint_NavigateInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Search_Hint_NavigateInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (` pour naviguer`)
		}),
		{
			parts: /** @type {(inputs: Search_Hint_NavigateInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-standalone", name: "up", options: {}, attributes: {} }, { type: "markup-standalone", name: "down", options: {}, attributes: {} }, { type: "text", value: " pour naviguer" }])
			})
		}
	)
);

const de_search_hint_navigate = /** @type {((inputs: Search_Hint_NavigateInputs) => LocalizedString) & { parts: (inputs: Search_Hint_NavigateInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Search_Hint_NavigateInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (` zum Navigieren`)
		}),
		{
			parts: /** @type {(inputs: Search_Hint_NavigateInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-standalone", name: "up", options: {}, attributes: {} }, { type: "markup-standalone", name: "down", options: {}, attributes: {} }, { type: "text", value: " zum Navigieren" }])
			})
		}
	)
);

const ru_search_hint_navigate = /** @type {((inputs: Search_Hint_NavigateInputs) => LocalizedString) & { parts: (inputs: Search_Hint_NavigateInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Search_Hint_NavigateInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (` для навигации`)
		}),
		{
			parts: /** @type {(inputs: Search_Hint_NavigateInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-standalone", name: "up", options: {}, attributes: {} }, { type: "markup-standalone", name: "down", options: {}, attributes: {} }, { type: "text", value: " для навигации" }])
			})
		}
	)
);

const it_search_hint_navigate = /** @type {((inputs: Search_Hint_NavigateInputs) => LocalizedString) & { parts: (inputs: Search_Hint_NavigateInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Search_Hint_NavigateInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (` per spostarti`)
		}),
		{
			parts: /** @type {(inputs: Search_Hint_NavigateInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-standalone", name: "up", options: {}, attributes: {} }, { type: "markup-standalone", name: "down", options: {}, attributes: {} }, { type: "text", value: " per spostarti" }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "to navigate" |
*
* @param {Search_Hint_NavigateInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const search_hint_navigate = /** @type {((inputs?: Search_Hint_NavigateInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & { parts: (inputs?: Search_Hint_NavigateInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Search_Hint_NavigateInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, { down: { options: {}; attributes: {}; children: false }; up: { options: {}; attributes: {}; children: false } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Search_Hint_NavigateInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "zh-Hans") return zh_hans1_search_hint_navigate(inputs)
			if (locale === "pt-BR") return pt_br2_search_hint_navigate(inputs)
			if (locale === "es") return es_search_hint_navigate(inputs)
			if (locale === "fr") return fr_search_hint_navigate(inputs)
			if (locale === "de") return de_search_hint_navigate(inputs)
			if (locale === "ru") return ru_search_hint_navigate(inputs)
			if (locale === "it") return it_search_hint_navigate(inputs)
			return en_search_hint_navigate(inputs)
		}),
		{
			parts: /** @type {(inputs?: Search_Hint_NavigateInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "zh-Hans") return typeof zh_hans1_search_hint_navigate.parts === "function" ? zh_hans1_search_hint_navigate.parts(inputs) : [{ type: "text", value: zh_hans1_search_hint_navigate(inputs) }]
				if (locale === "pt-BR") return typeof pt_br2_search_hint_navigate.parts === "function" ? pt_br2_search_hint_navigate.parts(inputs) : [{ type: "text", value: pt_br2_search_hint_navigate(inputs) }]
				if (locale === "es") return typeof es_search_hint_navigate.parts === "function" ? es_search_hint_navigate.parts(inputs) : [{ type: "text", value: es_search_hint_navigate(inputs) }]
				if (locale === "fr") return typeof fr_search_hint_navigate.parts === "function" ? fr_search_hint_navigate.parts(inputs) : [{ type: "text", value: fr_search_hint_navigate(inputs) }]
				if (locale === "de") return typeof de_search_hint_navigate.parts === "function" ? de_search_hint_navigate.parts(inputs) : [{ type: "text", value: de_search_hint_navigate(inputs) }]
				if (locale === "ru") return typeof ru_search_hint_navigate.parts === "function" ? ru_search_hint_navigate.parts(inputs) : [{ type: "text", value: ru_search_hint_navigate(inputs) }]
				if (locale === "it") return typeof it_search_hint_navigate.parts === "function" ? it_search_hint_navigate.parts(inputs) : [{ type: "text", value: it_search_hint_navigate(inputs) }]
				return typeof en_search_hint_navigate.parts === "function" ? en_search_hint_navigate.parts(inputs) : [{ type: "text", value: en_search_hint_navigate(inputs) }]
			})
		}
	)
);